import script from "./EmojiDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmojiDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./EmojiDropdown.vue?vue&type=style&index=0&id=38c38d87&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c38d87"]])

export default __exports__